import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import type { TrustBannerProps } from '@noths/polaris-design-system-candidate-components';
import { TrustBanner } from '@noths/polaris-design-system-candidate-components';

import { SectionContainer } from 'src/components/molecules/SectionContainer/SectionContainer';
import { trackImpression } from 'src/tracking/common/trackImpression';
import type { TrackingContext } from 'src/types/TrackingContext';
import * as styles from './TrustBannerSection.styles';

export interface TrustBannerSectionProps extends TrustBannerProps {
  trackingPosition?: number;
  trackingTitle: string;
}

export const TrustBannerSection = ({
  trackingPosition,
  trackingTitle,
  ...trustBannerProps
}: TrustBannerSectionProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Trust banner',
  };
  const impressionRef = useImpressionRef<HTMLDivElement>(() => trackImpression(trackingContext));

  return (
    <SectionContainer maxWidth="full" wrapperStyles={styles.wrapper}>
      <div ref={impressionRef}>
        <TrustBanner {...trustBannerProps} />
      </div>
    </SectionContainer>
  );
};
